import * as _ from 'lodash';
import * as moment from 'moment';
import { FormEvent } from 'react';
import MaskedInput from 'react-maskedinput';
import { Col, ControlLabel, FormControl } from 'react-bootstrap';
import { IListItem, IRecipientContactInformation } from '@nkr/models/index';
import { FormGroupWrapper, ViewWrapper } from '../styles';

interface IProps {
    centerId: number,
    recipientId: number,
    data: IRecipientContactInformation,
    birthDateValid: boolean,
    stateList: IListItem[],
    onChange: (data: IRecipientContactInformation) => void,
}

const Content = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let id = e.currentTarget.id;
        let value = e.currentTarget.value;
        let data = _.cloneDeep(props.data);

        if(id === "state" && value === "0")
            return;
        data[id] = typeof value === 'number' ? parseInt(value) : value;

        props.onChange(data);
    };

    if (props.data == null) {
        return null;
    }

    return (
        <>
            <ViewWrapper horizontal>
                <div>
                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Email Address:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='emailAddress'
                                value={props.data.emailAddress}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>First Name:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='firstName'
                                value={props.data.firstName}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Last Name:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='lastName'
                                value={props.data.lastName}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper validationState={props.birthDateValid == false ? 'error' : null}>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Date of Birth:</Col>
                        <Col xs={12} lg={3}>
                            <MaskedInput
                                id='birthDate'
                                name='birthDate'
                                className='form-control'
                                mask={'11/11/1111'}
                                value={moment(props.data.birthDate).format('MM/DD/YYYY')}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Address 1:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='address'
                                name='address'
                                value={props.data.address}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Address 2:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='address2'
                                name='address2'
                                value={props.data.address2}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>City:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='city'
                                name='city'
                                value={props.data.city}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>State:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                componentClass='select'
                                id='state'
                                name='state'
                                value={props.data.state}
                                onChange={handleDataChange}
                            >
                                <option value={''}>- SELECT -</option>
                                {props.stateList.map((stateType, index) =>
                                    <option key={`st-${index}`} value={stateType.abbreviation}>{stateType.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Postal Code:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='postalCode'
                                name='postalCode'
                                value={props.data.postalCode}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    <FormGroupWrapper>
                        <Col xs={12} lg={2} componentClass={ControlLabel}>Phone #:</Col>
                        <Col xs={12} lg={3}>
                            <FormControl
                                type='text'
                                id='phone'
                                name='phone'
                                value={props.data.phone}
                                onChange={handleDataChange}
                            />
                        </Col>
                    </FormGroupWrapper>
                </div>
            </ViewWrapper>
        </>
    );
}


export default Content;
